Selector.View.ResultView = Backbone.View.extend(
/** @lends Selector.View.ResultView# */
{	
	/** classname to give the generated element */
	className: "e_selector_item e_selector_result",
	
	/** tagname to give this generated element */
	tagName: "div",

	/** template to use for Underscore.js rendering */
	template: _.template($('#selector_result').html()),

    events: {
        "click .e_selector_print": 	"printResults",
        "click #landscape_tabs a": "changeResultTab"
    },

    changeResultTab: function(e){
	    $(e.currentTarget).addClass("active").siblings().removeClass("active");
	    this.$el.find(".landscape_tab_target").hide();
	    this.$el.find("." + e.currentTarget.dataset.target).show();
    },

    initialize: function() {
        var _this = this;

        _.bindAll(this, "render");
        _.bindAll(this, "fetchProduct");
        this.model.on('change',this.render);
        this.model.on('fetchProduct',this.fetchProduct);
        this.setElement($(".e_selector_results"));
    },

    fetchProduct: function(){
	    var _this = this;
	    var result = this.model.fetchProduct();

	    if (result) {
            result.then(function(){
                ele.selector.data.fetchedData = _this.model.attributes;
                _this.render();
            });
        }
    },

	/** Render function */
	render: function() {

	    var _this = this;

		this.$el.html(this.template({
            resultsStart: ele.selector.data.TEXT.RESULTSSTART,
            resultsFinish: ele.selector.data.TEXT.RESULTSFINISH,
            noResultsText: ele.selector.data.TEXT.NORESULTS,
            resultText: ele.selector.data.TEXT.RESULTTITLE,
            results: this.model.get("results")
        }));//render the HTML

        if (ele.uri.getParameterByName(window.location.href, "sendEvents")) {
            window.parent.document.dispatchEvent(new CustomEvent('resizeIframe'));
        }

        //go through landscape results and add in icons
        $(".icon").each(function(){
            var group = $(this).data('group'),
                icon = _this.model.get("icons")[group];

            //lookup question for this group and get icon answer
            $(this).html('<img src="/common/images/landscape/icons/' + icon.ICON + '.svg" alt="' + icon.ALT + '">');
        });

		return this; //needed in order to chain rendering
	},

    printResults: function(){
        ele.print.printContent(".e_selector_result");
    }

});